// import React from 'react'
import { connect } from 'react-redux'

// Import the component to be rendred
import { AmbassadorContentBlock } from '../components/AmbassadorContentBlock'
import * as selectors from 'app/selectors'
import * as ambassadorSelectors from '../selectors'
import { actions as ambassadorActions } from '../actions'
import { actions as ambassadorApiActions } from '../../api/actions'

// Interfaces
interface StateToProps {
    showModule: boolean
    ambassadorSettings?: AmbassadorSettingsDto
    subTitleStyle?: React.CSSProperties
    titleStyle?: React.CSSProperties
    data?: InitiativeDataRecord[]
    progressStyle?: React.CSSProperties
    challengeData?: ChallengeDataRecord[]
    currentIndex?: number
    showModal?: boolean
    challengeCurrentIndex?: number
    selectedChallengeIndex: number
    afterSocialShareUrl?: string
    onAmbassadorProfile:boolean
    ambassadorProfile: AmbassadorProfileRecord
}

interface SelectorsToProps {
    getDaysRemaining: (EndDate: string) => string
    getConvertedCurrencyValue: (value: number) => string
    getFormatedDate: (date: string) => string
    getPercentageFunded: (currentValue: number, goalvalue: number) => number
    changeInitiativeIndex: (mode: string, currentIndex: number, totalLength: number, callback: (index: number) => void) => void
}

// connect dispatch to props
export const mapDispatchToProps = (dispatch: any) => {
    const { populatCurrentIndex, toggleModal, populatChallengeCurrentIndex, populatAfterSocialShareUrl, populatSelectedChallengeIndex, onAmbassadorProfile } = ambassadorActions
    const { startGetChallengeData, startAfterSocialShare, startAmbassadorProfile } = ambassadorApiActions
    return {
        updateCurrentIndex: (index: number) => dispatch(populatCurrentIndex(index)),
        updateChallengeCurrentIndex: (index: number) => dispatch(populatChallengeCurrentIndex(index)),
        updateAfterSocialShareUrl: (postUrl: string) => dispatch(populatAfterSocialShareUrl(postUrl)),
        getChallenge: () => dispatch(startGetChallengeData()),
        updateAfterSocialShare: () => dispatch(startAfterSocialShare()),
        toggleModal: () => dispatch(toggleModal()),
        updateSelectedChallengeIndex: (index: number) => dispatch(populatSelectedChallengeIndex(index)),
        updateOnAmbassadorProfile: (flag: boolean) => dispatch(onAmbassadorProfile(flag)),
        getAmbassadorProfile: (ambassadorId: number) => dispatch(startAmbassadorProfile(ambassadorId)),
    }
}

// connect the component to redux
export const mapStateToProps = (state: RootState): StateToProps & SelectorsToProps => {
    const showModule = imod.cms.scoreboards.overrideDisplayDate || ambassadorSelectors.getShowModule(state)
    const ambassadorSettings = selectors.getInstanceSettings(state) as AmbassadorSettingsDto | undefined
    const titleStyle = ambassadorSelectors.getTitleTextStyle(state) as React.CSSProperties
    const subTitleStyle = ambassadorSelectors.getSubTitleTextStyle(state) as React.CSSProperties
    const data = state.ambassador && state.ambassador.data
    const challengeData = state.ambassador && state.ambassador.challengeData
    const currentIndex = state.ambassador && state.ambassador.currentIndex
    const challengeCurrentIndex = state.ambassador && state.ambassador.challengeCurrentIndex
    const selectedChallengeIndex = (state.ambassador && state.ambassador.selectedChallengeIndex) ? state.ambassador.selectedChallengeIndex : -1
    const afterSocialShareUrl = state.ambassador && state.ambassador.afterSocialShareUrl
    const progressStyle = ambassadorSelectors.getProgressStyle(state) as React.CSSProperties
    const getDaysRemaining = ambassadorSelectors.getDaysRemaining
    const getConvertedCurrencyValue = ambassadorSelectors.getConvertedCurrencyValue
    const getFormatedDate = ambassadorSelectors.getFormatedDate
    const getPercentageFunded = ambassadorSelectors.getPercentageFunded
    const showModal = ambassadorSelectors.showModal(state)
    const changeInitiativeIndex = ambassadorSelectors.changeInitiativeIndex
    const onAmbassadorProfile = (state.ambassador && state.ambassador.onAmbassadorProfile) ? state.ambassador.onAmbassadorProfile : false
    const ambassadorProfile = (state.ambassador && state.ambassador.ambassadorProfile) ? state.ambassador.ambassadorProfile : {} as AmbassadorProfileRecord
    return {
        data,
        challengeData,
        currentIndex,
        challengeCurrentIndex,
        selectedChallengeIndex,
        showModule,
        ambassadorSettings,
        titleStyle,
        subTitleStyle,
        progressStyle,
        getDaysRemaining,
        getConvertedCurrencyValue,
        getFormatedDate,
        getPercentageFunded,
        showModal,
        changeInitiativeIndex,
        afterSocialShareUrl,
        onAmbassadorProfile,
        ambassadorProfile,
    }
}

export const Ambassador = connect(mapStateToProps, mapDispatchToProps)(AmbassadorContentBlock)
